import { scenarios } from './scenarios.js';

export function installTestApi({ bus, clock, featureFlags, getSnapshot }) {
  const api = Object.freeze({
    version: '32.0.0-dev',
    channel: __BUILD_CHANNEL__,
    commit: __BUILD_COMMIT__,
    listScenarios: () => scenarios.map((scenario) => ({ ...scenario })),
    startScenario: (id) => {
      const scenario = scenarios.find((entry) => entry.id === id);
      if (!scenario) throw new Error(`Unknown scenario: ${id}`);
      bus.emit('scenario:start', scenario);
      return { ok: true, scenario: { ...scenario } };
    },
    setTime: (timeOfDay) => {
      bus.emit('world:set-time', { timeOfDay });
      return { ok: true, timeOfDay };
    },
    setWeather: (weather) => {
      bus.emit('world:set-weather', { weather });
      return { ok: true, weather };
    },
    setTimeScale: (scale) => {
      clock.setTimeScale(scale);
      return clock.snapshot();
    },
    pause: () => {
      clock.setPaused(true);
      return clock.snapshot();
    },
    resume: () => {
      clock.setPaused(false);
      return clock.snapshot();
    },
    advanceSimulation: (seconds) => {
      const steps = clock.advance(seconds, (delta, time) => bus.emit('simulation:step', { delta, time }));
      return { ok: true, steps, clock: clock.snapshot() };
    },
    setFeatureFlag: (name, enabled) => {
      featureFlags.set(name, enabled);
      return featureFlags.snapshot();
    },
    captureSnapshot: () => ({
      capturedAt: new Date().toISOString(),
      channel: __BUILD_CHANNEL__,
      commit: __BUILD_COMMIT__,
      clock: clock.snapshot(),
      features: featureFlags.snapshot(),
      game: getSnapshot(),
    }),
  });

  Object.defineProperty(window, '__SERPENT_TEST__', {
    configurable: true,
    enumerable: false,
    value: api,
  });

  return api;
}
